import React from 'react';
import ErrorBoundaryView, { NotFoundView } from '../views/ErrorBoundaryView';
import RootLayout from '../layouts/RootLayout';
import AppRoutes from './AppRoutes';
import SuperadminRoutes from './SuperadminRoutes';

const RootRoutes = {
  path: '/',
  element: <RootLayout />,
  errorElement: <ErrorBoundaryView />,
  children: [
    AppRoutes,
    SuperadminRoutes,
    {
      path: '*',
      element: <NotFoundView />,
    },
  ],
};

export default RootRoutes;
